module.exports = __webpack_public_path__ + "img/07.ebbba4eb.jpg";